(function () {
  const root = document.getElementById('dsh-configurator-v1');
  if (!root || root.dataset.cartUiReady === 'true') return;

  const box = root.querySelector('[data-dsh-cart-ui]');
  const countEl = root.querySelector('[data-dsh-cart-count]');
  const subtotalEl = root.querySelector('[data-dsh-cart-subtotal]');
  const itemsEl = root.querySelector('[data-dsh-cart-items]');
  const checkoutButton = root.querySelector('[data-dsh-cart-checkout]');
  const messageEl = root.querySelector('[data-dsh-cart-message]');
  const addButton = root.querySelector('[data-cart-button]');

  if (
    !box ||
    !countEl ||
    !subtotalEl ||
    !itemsEl ||
    !checkoutButton ||
    !messageEl
  ) {
    return;
  }

  root.dataset.cartUiReady = 'true';

  const CART_STORAGE_KEY = 'adena365:dsh-cart:v1';
  const CHECKOUT_KEY_STORAGE_KEY = 'adena365:dsh-checkout-key:v1';
  const CHECKOUT_URL =
    'https://test-konfigurator.adena365.de/api/dsh/cart/checkout';

  const SHOPIFY_CART_SIGNATURE_KEY =
    'adena365:dsh-shopify-cart-signature:v1';

  function loadCart() {
    try {
      const raw =
        window.localStorage.getItem(
          CART_STORAGE_KEY
        );

      if (!raw) {
        return { items: [] };
      }

      const parsed =
        JSON.parse(raw);

      return {
        items:
          Array.isArray(parsed.items)
            ? parsed.items.slice(0, 25)
            : []
      };

    } catch (error) {
      return { items: [] };
    }
  }

  function saveCart(cart) {
    window.localStorage.setItem(
      CART_STORAGE_KEY,
      JSON.stringify(cart)
    );

    window.localStorage.removeItem(
      CHECKOUT_KEY_STORAGE_KEY
    );
  }

  function displayMoney(cents) {
    return (
      Number(cents) / 100
    ).toLocaleString(
      'de-DE',
      {
        style: 'currency',
        currency: 'EUR'
      }
    );
  }

  function displayNumber(value) {
    return Number(value).toLocaleString(
      'de-DE',
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }
    );
  }

  function setMessage(message) {
    messageEl.textContent =
      message || '';

    messageEl.hidden =
      !message;
  }

  function removeItem(id) {
    const cart =
      loadCart();

    saveCart({
      items:
        cart.items.filter(
          function (item) {
            return item.id !== id;
          }
        )
    });

    render();
  }

  function render() {
    const cart =
      loadCart();

    const count =
      cart.items.length;

    box.hidden =
      count < 1;

    itemsEl.innerHTML =
      '';

    checkoutButton.disabled =
      count < 1;

    if (count < 1) {
      setMessage('');
      return;
    }

    const pieces =
      cart.items.reduce(
        function (sum, item) {
          return (
            sum +
            Number(
              item.request
                ?.configuration
                ?.quantity || 0
            )
          );
        },
        0
      );

    const subtotal =
      cart.items.reduce(
        function (sum, item) {
          return (
            sum +
            Number(
              item.priceSnapshot
                ?.grossProductPriceCents || 0
            )
          );
        },
        0
      );

    countEl.textContent =
      count === 1
        ? '1 Position · ' +
          pieces +
          ' Stück'
        : count +
          ' Positionen · ' +
          pieces +
          ' Stück';

    subtotalEl.textContent =
      displayMoney(subtotal);

    cart.items.forEach(
      function (item) {
        const config =
          item.request.configuration;

        const dims =
          config.dimensions;

        const isDisc =
          config.productType ===
          'disc';

        const row =
          document.createElement(
            'div'
          );

        row.className =
          'dsh-cart-ui__item';

        const copy =
          document.createElement(
            'div'
          );

        copy.className =
          'dsh-cart-ui__item-copy';

        const title =
          document.createElement(
            'strong'
          );

        title.textContent =
          isDisc
            ? 'Distanzscheibe'
            : 'Distanzhülse';

        const dimension =
          document.createElement(
            'span'
          );

        dimension.textContent =
          'AD ' +
          displayNumber(
            dims.outerDiameterMm
          ) +
          ' × ID ' +
          displayNumber(
            dims.innerDiameterMm
          ) +
          ' × ' +
          (
            isDisc
              ? 'H'
              : 'L'
          ) +
          ' ' +
          displayNumber(
            dims.thirdDimensionMm
          ) +
          ' mm';

        const quantity =
          document.createElement(
            'span'
          );

        quantity.textContent =
          config.quantity +
          ' Stück';

        copy.appendChild(
          title
        );

        copy.appendChild(
          dimension
        );

        copy.appendChild(
          quantity
        );

        const actions =
          document.createElement(
            'div'
          );

        actions.className =
          'dsh-cart-ui__item-actions';

        const price =
          document.createElement(
            'strong'
          );

        price.textContent =
          displayMoney(
            item.priceSnapshot
              .grossProductPriceCents
          );

        const remove =
          document.createElement(
            'button'
          );

        remove.type =
          'button';

        remove.className =
          'dsh-cart-ui__remove';

        remove.textContent =
          'Entfernen';

        remove.addEventListener(
          'click',
          function () {
            removeItem(
              item.id
            );
          }
        );

        actions.appendChild(
          price
        );

        actions.appendChild(
          remove
        );

        row.appendChild(
          copy
        );

        row.appendChild(
          actions
        );

        itemsEl.appendChild(
          row
        );
      }
    );
  }

  function isUuidV4(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      .test(
        value || ''
      );
  }

  function createUuidV4() {
    if (
      window.crypto &&
      typeof window.crypto.randomUUID ===
        'function'
    ) {
      return window.crypto.randomUUID();
    }

    const bytes =
      new Uint8Array(16);

    window.crypto.getRandomValues(
      bytes
    );

    bytes[6] =
      (bytes[6] & 15) | 64;

    bytes[8] =
      (bytes[8] & 63) | 128;

    const hex =
      Array.from(bytes).map(
        function (byte) {
          return byte
            .toString(16)
            .padStart(2, '0');
        }
      );

    return (
      hex.slice(0,4).join('') +
      '-' +
      hex.slice(4,6).join('') +
      '-' +
      hex.slice(6,8).join('') +
      '-' +
      hex.slice(8,10).join('') +
      '-' +
      hex.slice(10,16).join('')
    );
  }

  function getCheckoutKey() {
    const stored =
      window.localStorage.getItem(
        CHECKOUT_KEY_STORAGE_KEY
      );

    if (
      isUuidV4(stored)
    ) {
      return stored.toLowerCase();
    }

    const created =
      createUuidV4()
        .toLowerCase();

    window.localStorage.setItem(
      CHECKOUT_KEY_STORAGE_KEY,
      created
    );

    return created;
  }

  async function loadShopifyCartItems() {
    const response =
      await fetch(
        '/cart.js',
        {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            'Accept':
              'application/json'
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        'Shopify-Warenkorb konnte nicht geladen werden.'
      );
    }

    const cart =
      await response.json();

    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {
      throw new Error(
        'Shopify-Warenkorb hat ein ungültiges Format.'
      );
    }

    const quantitiesByVariant =
      new Map();

    cart.items.forEach(
      function (item) {
        const variantId =
          String(
            item.variant_id || ''
          );

        const quantity =
          Number(
            item.quantity
          );

        if (
          !/^\d+$/.test(variantId) ||
          !Number.isSafeInteger(quantity) ||
          quantity < 1
        ) {
          throw new Error(
            'Shopify-Warenkorb enthält eine ungültige Position.'
          );
        }

        const gid =
          'gid://shopify/ProductVariant/' +
          variantId;

        quantitiesByVariant.set(
          gid,
          (
            quantitiesByVariant.get(gid) ||
            0
          ) +
          quantity
        );
      }
    );

    const items =
      Array.from(
        quantitiesByVariant.entries()
      )
      .map(
        function (entry) {
          return {
            variantId:
              entry[0],

            quantity:
              entry[1]
          };
        }
      )
      .sort(
        function (a, b) {
          return a.variantId.localeCompare(
            b.variantId
          );
        }
      );

    if (items.length > 50) {
      throw new Error(
        'Der Shopify-Warenkorb enthält zu viele Positionen.'
      );
    }

    items.forEach(
      function (item) {
        if (item.quantity > 999) {
          throw new Error(
            'Eine Shopify-Warenkorbposition überschreitet die unterstützte Menge.'
          );
        }
      }
    );

    return items;
  }

  function syncCheckoutKeyWithShopifyCart(
    shopifyItems
  ) {
    const signature =
      JSON.stringify(
        shopifyItems
      );

    const previous =
      window.localStorage.getItem(
        SHOPIFY_CART_SIGNATURE_KEY
      );

    if (
      previous !== null &&
      previous !== signature
    ) {
      window.localStorage.removeItem(
        CHECKOUT_KEY_STORAGE_KEY
      );
    }

    window.localStorage.setItem(
      SHOPIFY_CART_SIGNATURE_KEY,
      signature
    );
  }

  checkoutButton.addEventListener(
    'click',
    async function () {
      const cart =
        loadCart();

      if (
        cart.items.length < 1
      ) {
        render();
        return;
      }

      checkoutButton.disabled =
        true;

      checkoutButton.textContent =
        'Warenkorb wird geprüft …';

      setMessage('');

      try {
        const shopifyItems =
          await loadShopifyCartItems();

        syncCheckoutKeyWithShopifyCart(
          shopifyItems
        );

        const response =
          await fetch(
            CHECKOUT_URL,
            {
              method: 'POST',
              mode: 'cors',
              headers: {
                'Content-Type':
                  'application/json'
              },
              body:
                JSON.stringify({
                  checkoutKey:
                    getCheckoutKey(),

                  items:
                    cart.items.map(
                      function (item) {
                        return item.request;
                      }
                    ),

                  shopifyItems:
                    shopifyItems
                })
            }
          );

        const payload =
          await response.json();

        if (
          response.ok &&
          payload.status ===
            'checkout-ready' &&
          payload.checkout &&
          payload.checkout.invoiceUrl
        ) {
          window.location.assign(
            payload.checkout.invoiceUrl
          );

          return;
        }

        if (
          response.ok &&
          payload.status ===
            'staging-ready'
        ) {
          const normalCount =
            shopifyItems.length;

          const positionText =
            payload.summary.itemsCount === 1
              ? '1 Position'
              : payload.summary.itemsCount +
                ' Positionen';

          const normalText =
            normalCount > 0
              ? ' inklusive ' +
                normalCount +
                (
                  normalCount === 1
                    ? ' Shopify-Artikel'
                    : ' Shopify-Artikeln'
                )
              : '';

          setMessage(
            'Gemeinsam geprüft: ' +
            positionText +
            normalText +
            ' · ' +
            displayMoney(
              payload.summary
                .totalCents
            ) +
            ' Gesamtbetrag. Im Staging wurde noch kein Shopify-Checkout erzeugt.'
          );

          return;
        }

        setMessage(
          payload &&
          payload.message
            ? payload.message
            : 'Der Warenkorb konnte nicht geprüft werden.'
        );

      } catch (error) {
        setMessage(
          error &&
          typeof error.message === 'string'
            ? error.message
            : 'Der Warenkorb konnte technisch nicht geprüft werden.'
        );

      } finally {
        checkoutButton.disabled =
          false;

        checkoutButton.textContent =
          'Warenkorb prüfen';
      }
    }
  );

  if (addButton) {
    addButton.addEventListener(
      'click',
      function () {
        window.setTimeout(
          render,
          0
        );
      }
    );
  }

  window.addEventListener(
    'storage',
    function (event) {
      if (
        event.key ===
        CART_STORAGE_KEY
      ) {
        render();
      }
    }
  );

  render();
})();